export default __webpack_public_path__ + "static/media/portrait_vs_landscape.0b0a8b4c.jpg";